<template>
  <div id="term-condition">
    <section class="py-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h4 class="text-center pb-4 mt-4 mt-lg-0"><b>ข้อกำหนดและเงื่อนไข</b></h4>
            <h5><b>1. บทนำ</b></h5>
            <div class="pb-3">ยินดีต้อนรับสู่ www.rentalagentcloud.com โดยเว็บไซต์นี้ได้จัดทำขึ้นและดำเนินการโดย บริษัท พลัส
              พร็อพเพอร์ตี้ จำกัด (“บริษัท”) เพื่อเผยแพร่ข้อมูลเกี่ยวกับรายละเอียดของโครงการที่พักอาศัยทั้งคอนโดมิเนียม
              บ้านเดี่ยว ทาวน์เฮาส์ อาคารพาณิชย์ และโครงการอื่นๆที่บริษัทดำเนินการบริหารงานขายและให้เช่า
              รวมถึงบริการต่างๆ ที่ดำเนินการโดยบริษัท บริษัทในเครือ บริษัทร่วมทุน และ/หรือ พาร์ทเนอร์ (partner)
              ของบริษัท (“บริษัทร่วม”) รวมถึงเพื่อให้ท่านค้นหาผลิตภัณฑ์และบริการ ตรวจสอบข่าวสารและโปรโมชันล่าสุด
              (“ผลิตภัณฑ์และการบริการ”) ตลอดจนการดำเนินการใดเกี่ยวกับผลิตภัณฑ์และบริการผ่านเว็บไซต์
              โดยเว็บไซต์จะมีการปรับปรุงอย่างต่อเนื่อง
              และอาจใช้อุปกรณ์ซอฟต์แวร์เพื่อการเก็บรวบรวมข้อมูลในด้านพฤติการณ์การใช้บริการของผู้เข้าชมเว็บไซต์ได้เพื่อวัตถุประสงค์ในการปรับปรุงเว็บไซต์ให้เข้าถึงกลุ่มเป้าหมาย
              ทั้งนี้ ก่อนที่ท่านจะใช้งานเว็บไซต์นี้
              ท่านจะต้องอ่านและทำความเข้าใจข้อกำหนดและเงื่อนไขและนโยบายการรักษาความลับส่วนบุคคลของเว็บไซต์นี้อย่างละเอียด
              ดังนั้น
              หากท่านไม่สามารถยอมรับข้อกำหนดและเงื่อนไขและนโยบายการรักษาความลับส่วนบุคคลในการใช้งานเว็บไซต์นี้ได้ทั้งหมดหรือแต่บางส่วน
              ขอให้ท่านยุติการใช้งานเว็บไซต์นี้โดยทันที แต่ทั้งนี้หากท่านใช้งานเว็บไซต์ต่อไป
              ให้ถือว่าท่านได้ยินยอมตามข้อกำหนดและเงื่อนไขและนโยบายการรักษาความลับส่วนบุคคลของบริษัทแล้วทุกประการ</div>
            <h5><b>2. วัตถุประสงค์</b></h5>
            <div class="pb-3">วัตถุประสงค์ของข้อกำหนดและเงื่อนไขมีขึ้นเพื่อกำหนดสิทธิและหน้าที่ระหว่างท่านกับบริษัท
              ตลอดจนขั้นตอนสำหรับการใช้งานเว็บไซต์ และการเข้าใช้เว็บไซต์นี้ให้ถือว่าท่านยอมรับและ
              ตกลงที่จะปฏิบัติและผูกพันภายใต้ข้อกำหนดและเงื่อนไขนี้ ทั้งนี้
              บริษัทอาจเปลี่ยนแปลงข้อกำหนดและเงื่อนไขการใช้บริการได้ทุกเมื่อตามดุลยพินิจของบริษัท</div>
            <h5><b>3. ทรัพย์สินทางปัญญา</b></h5>
            <div class="pb-3">3.1 ท่านตกลงและยอมรับว่า บรรดาข้อมูล ข้อความ รูปภาพ เสียง โลโก้ และ/หรือส่วนหนึ่งส่วนใดของเว็บไซต์นี้
              รวมถึงแต่ไม่จำกัดเพียงเฉพาะ ลิขสิทธิ์
              เครื่องหมายการค้า เครื่องหมายบริการ ชื่อทางการค้า ฐานข้อมูล ความลับทางการค้า สิทธิบัตร โนว์ฮาว
              ข้อมูลธุรกิจ ฯลฯ ที่ปรากฏบนเว็บไซต์ เป็น
              กรรมสิทธิ์และสิทธิในทรัพย์สินทางปัญญา ของบริษัท แต่เพียงผู้เดียว<br>
              3.2 ว้นแต่จะได้มีการกำหนดไว้เป็นอย่างอื่น ทรัพย์สินทางปัญญาใดๆ ที่บริษัท ได้จัดทำขึ้นหรือนำมาใช้บนเว็บไซต์
              บริษัทมีสิทธิแต่เพียงผู้เดียวในการใช้หรือ
              อนุญาตให้ใช้งานทรัพย์สินทางปัญญาดังกล่าว โดยที่ท่านตกลงจะไม่คัดลอก ทำซ้ำ แก้ไข ดัดแปลง ต่อยอด อนุญาตให้ใช้
              หรือ กระทำการใดๆ อันเป็นการ
              ละเมิดต่อสิทธิในทรัพย์สินทางปัญญาของบริษัทโดยเด็ดขาด<br>
              3.3 การผิดเงื่อนไขของข้อตกลงข้อนี้ให้ถือว่าเป็นการกระทำผิดในสาระสำคัญของข้อกำหนดและเงื่อนไข
              โดยบริษัทมีสิทธิเรียกร้องค่าเสียหายจากท่านได้ทันที</div>
            <h5><b>4. สิทธิและหน้าที่ของท่าน</b></h5>
            <div class="pb-3">4.1 ท่านจะใช้งานเว็บไซต์นี้ เพื่อวัตถุประสงค์ที่ได้รับอนุญาตตามข้อกำหนดและเงื่อนไขของบริษัทเท่านั้น
              โดยการใช้งานดังกล่าวของท่านจะต้องไม่ขัดต่อ กฏ
              หมาย กฎ ระเบียบ ข้อบังคับ หรือ หลักปฏิบัติที่เป็นที่ยอมรับโดยทั่วไป<br>
              4.2 ท่านต้องไม่เข้าใช้หรือพยายามเข้าใช้บริการหนึ่งบริการใด โดยวิธีอื่นรวมถึงการใช้วิธีการอัตโนมัติ เช่น
              การใช้สคริปต์ (ชุดคำสั่งหรือภาษาคอมพิวเตอร์เพื่อ
              แฝงตัวเข้าสู่ระบบท่าน) นอกจากช่องทางที่บริษัทได้กำหนดไว้ เว้นแต่
              ท่านจะได้รับอนุญาตเป็นลายลักษณ์อักษรจากบริษัท<br>
              4.3 ท่านต้องไม่ทำ หรือมีส่วนร่วมในการขัดขวางหรือรบกวนการใช้งานเว็บไซต์
              รวมทั้งเข้าไปยุ่งเกี่ยวกับเครื่องแม่ข่ายและเครือข่ายที่เชื่อมต่อกับการใช้งานของ
              เว็บไซต์นี้อย่างเด็ดขาด<br>
              4.4 ในการใช้งานเว็บไซต์ ท่านต้องไม่กระทำการใดอันขัดต่อกฎหมาย และขัดต่อความสงบเรียบร้อย
              หรือศีลธรรมอันดีของประชาชน ไม่ล่วงละเมิดสิทธิใดๆ ของ
              บริษัท ผู้ใช้งานรายอื่น และบุคคลอื่น และไม่กระทำการใดอันก่อให้เกิดความเสียหายแก่บุคคลดังกล่าวข้างต้น<br>
              4.5 ท่านต้องไม่ดำเนินการหรืออนุญาตให้บุคคลที่สามดำเนินการแก้ไขดัดแปลง แปล หรือ ทำวิศวกรรมย้อนกลับ (reverse
              engineer) ส่วนของเว็บไซต์
              กรอบของเว็บไซต์ หรือลอกเลียนแบบส่วนของบริการใดๆ จากเว็บไซต์ รวมทั้งละเมิดลิขสิทธิ์ เครื่องหมายการค้า
              หรือข้อมูลทรัพย์สินทางปัญญาอื่นๆ
              ของบริษัทหรือผู้ใช้งานรายอื่น รวมถึงไม่รวบรวมข้อมูลที่บริษัทสร้างขึ้น รวมทั้งรูปภาพ ภาพพื้นหลัง และไอคอน
              เพื่อวัตถุประสงค์ใดๆก็ตามเว้นแต่จะได้
              รับอนุญาตจากทางบริษัทเป็นลายลักษณ์อักษร<br>
              4.6 ท่านต้องไม่เขียนข้อความใดๆ
              ลงในเว็บไซต์หรือพื้นที่อื่นใดที่แสดงออกหรือมีนัยว่าข้อความดังกล่าวได้รับการสนับสนุนหรือรับรองจากบริษัทโดยไม่เป็น
              ความจริง หรือไม่ได้รับอนุญาตก่อน<br>
              4.7 ท่านต้องไม่ทำซ้ำ จัดพิมพ์ขึ้นใหม่ ดัดแปลง ดาวน์โหลด อัปโหลด ติดประกาศ เผยแพร่
              หรือกระทำการอื่นใดให้ปรากฎต่อสาธารณชนโดยไม่ได้รับอนุญาต
              เป็นลายลักษณ์อักษรจากบริษัทก่อนล่วงหน้า หากฝ่าฝืนต้องรับผิดตามกฎหมาย<br>
              4.8 ท่านต้องไม่กระทำละเมิดสิทธิในทรัพย์สินทางปัญญาของบริษัท โดยรวมถึงแต่ไม่จำกัดเพียง ลิขสิทธิ์ สิทธิบัตร
              เครื่องหมายการค้า ความลับทางการค้า
              หรือ ทรัพย์สินทางปัญญาอื่นไม่ว่าโดยวิธีการใด<br>
              4.9 ท่านต้องไม่ใช้เนื้อหา หรือ ข้อความ งานใดๆ จากเว็บไซต์นี้เพื่อแสวงหาประโยชน์
              โดยมิชอบโดยปราศจากความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจาก
              บริษัท และ/หรือตั้งกระทู้ หรือทำให้ปรากฏซึ่งข้อความที่ก่อให้เกิดความเสียหายต่อบริษัท
              ผู้ใช้งานอินเทอร์เน็ตรายอื่น และ/หรือบุคคลภายนอก</div>
            <h5><b>5. สิทธิของบริษัท</b></h5>
            <div class="pb-3">5.1 บริษัทมีสิทธิรวบรวมและประมวลผลข้อมูลของท่าน
              หากข้อมูลนั้นเป็นข้อมูลส่วนบุคคลบริษัทจะดำเนินการตามนโยบายการรักษาความลับส่วนบุคคล<br>
              5.2 บริษัทมีสิทธิเปลี่ยนแปลงข้อมูลใดๆ บนเว็บไซต์ได้แต่เพียงผู้เดียว
              รวมถึงรายละเอียดของผลิตภัณฑ์และการบริการ ทั้งนี้ คำตัดสินของบริษัทในเรื่องข้อมูล
              บนเว็บไซต์ถือเป็นที่สุด<br>
              5.3 บริษัทอาจโอนสิทธิการใช้ข้อมูลต่างๆ ในเว็บไซต์นี้แก่บริษัทในเครือ บริษัทร่วมทุน หรือ พาร์ทเนอร์
              (partner) ของบริษัท ภายใต้เงื่อนไขที่จะระบุในอนาคต
              และเป็นไปตามที่กฎหมายกำหนด<br>
              5.4 บริษัทอาจทำการขอข้อมูลเกี่ยวกับท่าน ในกรณีที่ท่านสร้างบัญชีบนเว็บไซต์
              หรือการจัดเก็บข้อมูลของท่านบนเว็บไซต์ เช่น ชื่อ นามสกุล ที่อยู่ ไปรษณีย์
              อิเล็กทรอนิกส์ (E-mail) หมายเลขโทรศัพท์ วันเกิด ความสนใจด้านที่อยู่อาศัยในแง่ต่างๆ เป็นต้น
              และท่านตกลงให้ความยินยอมแก่บริษัทในการเก็บ
              รวบรวมและประมวลผลข้อมูลส่วนบุคคลของท่านในการใช้บริการเว็บไซต์ดังกล่าว<br>
              5.5 ในกรณีที่มีการสร้างบัญชีบนเว็บไซต์ หรือการจัดเก็บข้อมูลของท่านบนเว็บไซต์
              บริษัทอาจส่งไปรษณีย์อิเล็กทรอนิกส์ (E-mail) หรือข้อความ
              อิเล็กทรอนิกส์อื่นใด เกี่ยวกับผลิตภัณฑ์และบริการที่ท่านอาจสนใจไปยังท่านเป็นคราวๆ ไป
              โดยท่านตกลงและยินยอมรับไปรษณีย์อิเล็กทรอนิกส์ (Email)
              หรือข้อความอิเล็กทรอนิกส์อื่นใดนี้ อย่างไรก็ตามท่านอาจใช้สิทธิปฏิเสธการรับไปรษณีย์อิเล็กทรอนิกส์ (Email)
              หรือข้อความอิเล็กทรอนิกส์ทั้งหมดตาม
              ช่องทางที่บริษัทได้จัดไว้ให้ ทั้งนี้ หากท่านปฏิเสธที่จะรับไปรษณีย์อิเล็กทรอนิกส์ (Email)
              หรือข้อความอิเล็กทรอนิกส์ทั้งหมด ท่านรับทราบว่าท่านอาจไม่
              สามารถใช้บริการของบริษัทได้อย่างครบถ้วน<br>
              5.6 ความเสียหายที่เกิดขึ้นแก่เว็บไซต์ บริษัท หรือกรรมการของบริษัท อันเนื่องมาจากท่าน
              บริษัทมีสิทธิเรียกร้องค่าเสียหายจากท่านได้ตามค่าใช้จ่าย และ
              /หรือค่าเสียหายที่เกิดขึ้นตามจริงไม่ว่าจะเพื่อแก้ไข ซ่อมแซม สร้างขึ้นใหม่ ชดเชย
              หรือกระทำการด้วยวิธีอื่นใดเพื่อชดเชยความเสียหายดังกล่าวของบริษัท
              ท่านต้องดำเนินการชดเชยค่าเสียหายให้ครบถ้วนภายในเวลาที่บริษัทกำหนด
              หากท่านผิดนัดไม่ชดเชยค่าเสียหายในเวลาที่กำหนด บริษัทมีสิทธิคิดดอกเบี้ย
              ผิดนัดจากต้นเงิน ตามอัตราที่กฎหมายกำหนด</div>
            <h5><b>6. การแก้ไขเพิ่มเติม</b></h5>
            <div class="pb-3">บริษัทขอสงวนสิทธิในการแก้ไข เปลี่ยนแปลง เพิ่มเติม ตัดทอน บรรดาข้อกำหนดและเงื่อนไขการใช้บริการใดๆ
              ที่กำหนดไว้ในเว็บไซต์นี้ ทั้งนี้ ท่านมีหน้าที่ติดตามการแก้ไขเปลี่ยนแปลงต่างๆ อยู่เสมอ
              และหากภายหลังการแก้ไขเปลี่ยนแปลง ท่านยังคงใช้บริการเว็บไซต์อยู่ให้ถือว่าท่านได้อ่านและเข้าใจ
              จึงได้ยอมรับตามข้อกำหนดและเงื่อนไขการใช้บริการที่ได้มีการเปลี่ยนแปลงนี้ อย่างไม่มีเงื่อนไข
              ท่านไม่อาจอ้างเหตุในการไม่ทราบถึงการเปลี่ยนแปลงข้อกำหนดและเงื่อนการใช้บริการมาเป็นเหตุในการฝ่าฝืนข้อกำหนดและเงื่อนไขนี้ได้
            </div>
            <h5><b>7. กฎหมายที่ใช้บังคับ</b></h5>
            <div>การตีความ และการบังคับตามข้อกำหนดและเงื่อนไขการให้งานเว็บไซต์นี้ให้เป็นไปตามกฎหมายไทย</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {}
</script>

<style scoped>
</style>